export default {
      id: "oc-xsky-usage",
      viewBox: "0 0 436 139",
      url: __webpack_public_path__ + "sprite.svg#oc-xsky",
      toString: function () {
        return this.url;
      }
    }